export default "assets/images/icons/account-0c52562b.svg";